"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBarModal = exports.defaultProps = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Dialog_1 = tslib_1.__importDefault(require("@material-ui/core/Dialog"));
var Buttons_1 = require("../Buttons");
var LoaderButton_1 = tslib_1.__importDefault(require("../Buttons/LoaderButton/LoaderButton"));
exports.defaultProps = {
    open: false,
    onClose: noop_1.default,
    closeBtnText: '',
    onConfirm: noop_1.default,
    onSecondary: noop_1.default,
    confirmBtnText: '',
    disableCloseIcon: true,
    isDisabled: false,
    isLoading: false,
};
exports.TopBarModal = function (_a) {
    var children = _a.children, closeBtnText = _a.closeBtnText, confirmBtnText = _a.confirmBtnText, title = _a.title, open = _a.open, disableCloseIcon = _a.disableCloseIcon, onClose = _a.onClose, onConfirm = _a.onConfirm, onSecondary = _a.onSecondary, isDisabled = _a.isDisabled, formId = _a.formId, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, rest = tslib_1.__rest(_a, ["children", "closeBtnText", "confirmBtnText", "title", "open", "disableCloseIcon", "onClose", "onConfirm", "onSecondary", "isDisabled", "formId", "isLoading"]);
    var showCancelButton = onClose && closeBtnText;
    var onCancel = function (event) {
        if (onSecondary) {
            onSecondary(event);
        }
        if (onClose) {
            onClose(event);
        }
    };
    var showConfirmButton = onConfirm && confirmBtnText;
    return (React.createElement(StyledDialog, tslib_1.__assign({ open: open, onBackdropClick: onClose, onEscapeKeyDown: onClose, fullWidth: true, classes: {
            paperWidthSm: 'TBM-paperWidthSm',
            paperScrollPaper: 'TBM-paperScrollPaper',
        }, PaperProps: {
            square: true,
        } }, rest),
        React.createElement(Header, { className: "top-bar-modal-header" },
            React.createElement(ButtonBar, null,
                React.createElement(Title, null, title),
                React.createElement(ButtonContainer, null,
                    showCancelButton && (React.createElement(ButtonWrapper, null,
                        React.createElement(Buttons_1.Button, { borderless: true, buttonStyle: "SECONDARY", onClick: onCancel }, closeBtnText))),
                    showConfirmButton && (React.createElement(ButtonWrapper, null,
                        React.createElement(LoaderButton_1.default, { borderless: true, type: "submit", form: formId, disabled: isLoading || isDisabled, onClick: onConfirm, loaderShow: isLoading }, confirmBtnText))),
                    React.createElement(ButtonWrapper, null, !disableCloseIcon && (React.createElement(Buttons_1.IconButton, { onClick: onClose, icon: "close" })))))),
        children));
};
var StyledDialog = styled_components_1.default(Dialog_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    width: 100%;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper {\n    width: 100%;\n    margin: 12px;\n    height: calc(100% - 24px);\n    max-height: none;\n    max-width: none;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper > div {\n    height: 100%;\n    padding: 0;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper .top-bar-modal-header {\n    height: 60px;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper .grid-detail-modal-container {\n    height: calc(100% - 60px);\n    background-color: '#F6F6F6';\n    width: 100%;\n  }\n"], ["\n  && {\n    width: 100%;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper {\n    width: 100%;\n    margin: 12px;\n    height: calc(100% - 24px);\n    max-height: none;\n    max-width: none;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper > div {\n    height: 100%;\n    padding: 0;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper .top-bar-modal-header {\n    height: 60px;\n  }\n\n  && .TBM-paperWidthSm.TBM-paperScrollPaper .grid-detail-modal-container {\n    height: calc(100% - 60px);\n    background-color: '#F6F6F6';\n    width: 100%;\n  }\n"])));
var Header = styled_components_1.default.div(function (props) { return ({
    '&&': {
        alignItems: 'center',
        color: props.theme.colors.NTDarkGrey[700],
        fontFamily: props.theme.fonts.robotoMedium,
        fontSize: '1.8rem',
        backgroundColor: '#EAEAEA',
        width: '100%',
        padding: 5,
        height: '60px',
    },
    '&& i': {
        fontSize: '2.4rem',
    },
}); });
var Title = styled_components_1.default.div(function (props) { return ({
    marginLeft: 15,
    color: props.theme.colors.NTDarkGrey[976],
    fontFamily: props.theme.fonts.robotoMedium,
    fontSize: '13px',
    fontWeight: 700,
    alignItems: 'center',
    lineHeight: '3.2rem',
    textAlign: 'center',
}); });
var ButtonWrapper = styled_components_1.default.div({
    marginLeft: 5,
    marginRight: 5,
});
var ButtonBar = styled_components_1.default.div({
    paddingTop: '14px',
    justifyContent: 'space-between',
    display: 'flex',
    width: '100%',
});
var ButtonContainer = styled_components_1.default.div({
    display: 'flex',
    justifyContent: 'space-between',
});
var templateObject_1;
